export default __webpack_public_path__ + "static/media/location.93a8dd13.svg";